<nav class="navbar navbar-expand-lg navbar-dark px-5 py-3 py-lg-0">
  <a routerLink="/" class="navbar-brand p-0">
    <img [src]="logoSrc" alt="Logo" class="img-fluid logo">
  </a>

  <button class="navbar-toggler" type="button" (click)="toggleMobileNav()">
    <span class="fa fa-bars"></span>
  </button>

  <!-- Overlay -->
  <div class="mobile-overlay" *ngIf="isMobile()" [class.show]="mobileNavOpen" (click)="toggleMobileNav()"></div>

  <!-- Mobile Nav Slide-in -->
  <div class="navbar-collapse"  [ngClass]="{ 'mobile-nav-open': mobileNavOpen }" id="navbarCollapse">
    <button class="navbar-toggler" type="button"  id="barMenuId" (click)="toggleMobileNav()">
      <span class="fa fa-bars"></span>
    </button>
    <div class="navbar-nav ms-auto py-0">
      <a routerLink="/" (click)="closeNav()" class="nav-item nav-link">Home</a>
      <nav-dropdown #industries [dropdownMenu]="industriesMenu" (closeBarMenu)="closeNav()" (opened)="onDropdownOpened(industries)" title="Industries"></nav-dropdown>
      <nav-dropdown #products [dropdownMenu]="productsMenu" (closeBarMenu)="closeNav()" (opened)="onDropdownOpened(products)" title="Products"></nav-dropdown>
      <nav-dropdown #services [dropdownMenu]="servicesMenu" (closeBarMenu)="closeNav()" (opened)="onDropdownOpened(services)" title="Services"></nav-dropdown>
      <a routerLink="/about" (click)="closeNav()" class="nav-item nav-link">About</a>
      <a routerLink="/contact" (click)="closeNav()" class="nav-item nav-link">Contact</a>
    </div>
    <button type="button" class="login-btn" (click)="onNavigate()">Portal</button>
  </div>
</nav>
